import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=2ee122e7&scoped=true&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"
import style0 from "./pricehelp.vue?vue&type=style&index=0&id=2ee122e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee122e7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ee122e7')) {
      api.createRecord('2ee122e7', component.options)
    } else {
      api.reload('2ee122e7', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=2ee122e7&scoped=true&", function () {
      api.rerender('2ee122e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2mhpJUw04PpRM/JS/pricehelp.vue"
export default component.exports